import { render, staticRenderFns } from "./FrequentTripSavings.vue?vue&type=template&id=47dbfc54&scoped=true"
import script from "./FrequentTripSavings.vue?vue&type=script&lang=ts"
export * from "./FrequentTripSavings.vue?vue&type=script&lang=ts"
import style0 from "./FrequentTripSavings.vue?vue&type=style&index=0&id=47dbfc54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dbfc54",
  null
  
)

export default component.exports